// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__6Q6sh","vLegacy":"SelectSecondary_vLegacy__1RxIH","error":"SelectSecondary_error__35JDf","disabled":"SelectSecondary_disabled__2JmqA"};